export const COUNTRY_DIALLING_CODES_DATA = [
  {
    diallingCode: "+93",
    label: "Afghanistan (+93)",
    countryCode: "AF",
  },
  {
    diallingCode: "+355",
    label: "Albania (+355)",
    countryCode: "AL",
  },
  {
    diallingCode: "+213",
    label: "Algeria (+213)",
    countryCode: "DZ",
  },
  {
    diallingCode: "+1-684",
    label: "American Samoa (+1-684)",
    countryCode: "AS",
  },
  {
    diallingCode: "+376",
    label: "Andorra (+376)",
    countryCode: "AD",
  },
  {
    diallingCode: "+244",
    label: "Angola (+244)",
    countryCode: "AO",
  },
  {
    diallingCode: "+1-264",
    label: "Anguilla (+1-264)",
    countryCode: "AI",
  },
  {
    diallingCode: "+672",
    label: "Antarctica (+672)",
    countryCode: "AQ",
  },
  {
    diallingCode: "+1-268",
    label: "Antigua And Barbuda (+1-268)",
    countryCode: "AG",
  },
  {
    diallingCode: "+54",
    label: "Argentina (+54)",
    countryCode: "AR",
  },
  {
    diallingCode: "+374",
    label: "Armenia (+374)",
    countryCode: "AM",
  },
  {
    diallingCode: "+297",
    label: "Aruba (+297)",
    countryCode: "AW",
  },
  {
    diallingCode: "+61",
    label: "Australia (+61)",
    countryCode: "AU",
  },
  {
    diallingCode: "+43",
    label: "Austria (+43)",
    countryCode: "AT",
  },
  {
    diallingCode: "+994",
    label: "Azerbaijan (+994)",
    countryCode: "AZ",
  },
  {
    diallingCode: "+1-242",
    label: "Bahamas (+1-242)",
    countryCode: "BS",
  },
  {
    diallingCode: "+973",
    label: "Bahrain (+973)",
    countryCode: "BH",
  },
  {
    diallingCode: "+880",
    label: "Bangladesh (+880)",
    countryCode: "BD",
  },
  {
    diallingCode: "+1-246",
    label: "Barbados (+1-246)",
    countryCode: "BB",
  },
  {
    diallingCode: "+375",
    label: "Belarus (+375)",
    countryCode: "BY",
  },
  {
    diallingCode: "+32",
    label: "Belgium (+32)",
    countryCode: "BE",
  },
  {
    diallingCode: "+501",
    label: "Belize (+501)",
    countryCode: "BZ",
  },
  {
    diallingCode: "+229",
    label: "Benin (+229)",
    countryCode: "BJ",
  },
  {
    diallingCode: "+1-441",
    label: "Bermuda (+1-441)",
    countryCode: "BM",
  },
  {
    diallingCode: "+975",
    label: "Bhutan (+975)",
    countryCode: "BT",
  },
  {
    diallingCode: "+591",
    label: "Bolivia (+591)",
    countryCode: "BO",
  },
  {
    diallingCode: "+599",
    label: "Bonaire (+599)",
    countryCode: "BQ",
  },
  {
    diallingCode: "+387",
    label: "Bosnia And Herzegovina (+387)",
    countryCode: "BA",
  },
  {
    diallingCode: "+267",
    label: "Botswana (+267)",
    countryCode: "BW",
  },
  {
    diallingCode: "+47",
    label: "Bouvet Island (+47)",
    countryCode: "BV",
  },
  {
    diallingCode: "+55",
    label: "Brazil (+55)",
    countryCode: "BR",
  },
  {
    diallingCode: "+246",
    label: "British Indian Ocean Territory (+246)",
    countryCode: "IO",
  },
  {
    diallingCode: "+1-284",
    label: "British Virgin Islands (+1-284)",
    countryCode: "VG",
  },
  {
    diallingCode: "+673",
    label: "Brunei Darussalam (+673)",
    countryCode: "BN",
  },
  {
    diallingCode: "+359",
    label: "Bulgaria (+359)",
    countryCode: "BG",
  },
  {
    diallingCode: "+226",
    label: "Burkina Faso (+226)",
    countryCode: "BF",
  },
  {
    diallingCode: "+257",
    label: "Burundi (+257)",
    countryCode: "BI",
  },
  {
    diallingCode: "+855",
    label: "Cambodia (+855)",
    countryCode: "KH",
  },
  {
    diallingCode: "+237",
    label: "Cameroon (+237)",
    countryCode: "CM",
  },
  {
    diallingCode: "+1",
    label: "Canada (+1)",
    countryCode: "CA",
  },
  {
    diallingCode: "+238",
    label: "Cape Verde (+238)",
    countryCode: "CV",
  },
  {
    diallingCode: "+1-345",
    label: "Cayman Islands (+1-345)",
    countryCode: "KY",
  },
  {
    diallingCode: "+236",
    label: "Central African Republic (+236)",
    countryCode: "CF",
  },
  {
    diallingCode: "+235",
    label: "Chad (+235)",
    countryCode: "TD",
  },
  {
    diallingCode: "+56",
    label: "Chile (+56)",
    countryCode: "CL",
  },
  {
    diallingCode: "+86",
    label: "China (+86)",
    countryCode: "CN",
  },
  {
    diallingCode: "+61",
    label: "Christmas Island (+61)",
    countryCode: "CX",
  },
  {
    diallingCode: "+61",
    label: "Cocos (Keeling) Islands (+61)",
    countryCode: "CC",
  },
  {
    diallingCode: "+57",
    label: "Colombia (+57)",
    countryCode: "CO",
  },
  {
    diallingCode: "+269",
    label: "Comoros (+269)",
    countryCode: "KM",
  },
  {
    diallingCode: "+242",
    label: "Congo (+242)",
    countryCode: "CG",
  },
  {
    diallingCode: "+243",
    label: "Congo (+243)",
    countryCode: "CD",
  },
  {
    diallingCode: "+682",
    label: "Cook Islands (+682)",
    countryCode: "CK",
  },
  {
    diallingCode: "+506",
    label: "Costa Rica (+506)",
    countryCode: "CR",
  },
  {
    diallingCode: "+385",
    label: "Croatia (+385)",
    countryCode: "HR",
  },
  {
    diallingCode: "+53",
    label: "Cuba (+53)",
    countryCode: "CU",
  },
  {
    diallingCode: "+599",
    label: "Curaçao (+599)",
    countryCode: "CW",
  },
  {
    diallingCode: "+357",
    label: "Cyprus (+357)",
    countryCode: "CY",
  },
  {
    diallingCode: "+420",
    label: "Czech Republic (+420)",
    countryCode: "CZ",
  },
  {
    diallingCode: "+45",
    label: "Denmark (+45)",
    countryCode: "DK",
  },
  {
    diallingCode: "+253",
    label: "Djibouti (+253)",
    countryCode: "DJ",
  },
  {
    diallingCode: "+1-767",
    label: "Dominica (+1-767)",
    countryCode: "DM",
  },
  {
    diallingCode: "+1-809",
    label: "Dominican Republic (+1-809)",
    countryCode: "DO",
  },
  {
    diallingCode: "+593",
    label: "Ecuador (+593)",
    countryCode: "EC",
  },
  {
    diallingCode: "+20",
    label: "Egypt (+20)",
    countryCode: "EG",
  },
  {
    diallingCode: "+503",
    label: "El Salvador (+503)",
    countryCode: "SV",
  },
  {
    diallingCode: "+240",
    label: "Equatorial Guinea (+240)",
    countryCode: "GQ",
  },
  {
    diallingCode: "+291",
    label: "Eritrea (+291)",
    countryCode: "ER",
  },
  {
    diallingCode: "+372",
    label: "Estonia (+372)",
    countryCode: "EE",
  },
  {
    diallingCode: "+251",
    label: "Ethiopia (+251)",
    countryCode: "ET",
  },
  {
    diallingCode: "+500",
    label: "Falkland Islands (+500)",
    countryCode: "FK",
  },
  {
    diallingCode: "+298",
    label: "Faroe Islands (+298)",
    countryCode: "FO",
  },
  {
    diallingCode: "+679",
    label: "Fiji (+679)",
    countryCode: "FJ",
  },
  {
    diallingCode: "+358",
    label: "Finland (+358)",
    countryCode: "FI",
  },
  {
    diallingCode: "+33",
    label: "France (+33)",
    countryCode: "FR",
  },
  {
    diallingCode: "+594",
    label: "French Guiana (+594)",
    countryCode: "GF",
  },
  {
    diallingCode: "+689",
    label: "French Polynesia (+689)",
    countryCode: "PF",
  },
  {
    diallingCode: "+262",
    label: "French Southern Territories (+262)",
    countryCode: "TF",
  },
  {
    diallingCode: "+241",
    label: "Gabon (+241)",
    countryCode: "GA",
  },
  {
    diallingCode: "+220",
    label: "Gambia (+220)",
    countryCode: "GM",
  },
  {
    diallingCode: "+995",
    label: "Georgia (+995)",
    countryCode: "GE",
  },
  {
    diallingCode: "+49",
    label: "Germany (+49)",
    countryCode: "DE",
  },
  {
    diallingCode: "+233",
    label: "Ghana (+233)",
    countryCode: "GH",
  },
  {
    diallingCode: "+350",
    label: "Gibraltar (+350)",
    countryCode: "GI",
  },
  {
    diallingCode: "+30",
    label: "Greece (+30)",
    countryCode: "GR",
  },
  {
    diallingCode: "+299",
    label: "Greenland (+299)",
    countryCode: "GL",
  },
  {
    diallingCode: "+1-473",
    label: "Grenada (+1-473)",
    countryCode: "GD",
  },
  {
    diallingCode: "+590",
    label: "Guadeloupe (+590)",
    countryCode: "GP",
  },
  {
    diallingCode: "+1-671",
    label: "Guam (+1-671)",
    countryCode: "GU",
  },
  {
    diallingCode: "+502",
    label: "Guatemala (+502)",
    countryCode: "GT",
  },
  {
    diallingCode: "+44",
    label: "Guernsey (+44)",
    countryCode: "GG",
  },
  {
    diallingCode: "+224",
    label: "Guinea (+224)",
    countryCode: "GN",
  },
  {
    diallingCode: "+245",
    label: "Guinea-Bissau (+245)",
    countryCode: "GW",
  },
  {
    diallingCode: "+592",
    label: "Guyana (+592)",
    countryCode: "GY",
  },
  {
    diallingCode: "+509",
    label: "Haiti (+509)",
    countryCode: "HT",
  },
  {
    diallingCode: "+672",
    label: "Heard Island And Mcdonald Islands (+672)",
    countryCode: "HM",
  },
  {
    diallingCode: "+379",
    label: "Holy (+379)",
    countryCode: "VA",
  },
  {
    diallingCode: "+504",
    label: "Honduras (+504)",
    countryCode: "HN",
  },
  {
    diallingCode: "+852",
    label: "Hong Kong (+852)",
    countryCode: "HK",
  },
  {
    diallingCode: "+36",
    label: "Hungary (+36)",
    countryCode: "HU",
  },
  {
    diallingCode: "+354",
    label: "Iceland (+354)",
    countryCode: "IS",
  },
  {
    diallingCode: "+91",
    label: "India (+91)",
    countryCode: "IN",
  },
  {
    diallingCode: "+62",
    label: "Indonesia (+62)",
    countryCode: "ID",
  },
  {
    diallingCode: "+98",
    label: "Iran (+98)",
    countryCode: "IR",
  },
  {
    diallingCode: "+964",
    label: "Iraq (+964)",
    countryCode: "IQ",
  },
  {
    diallingCode: "+353",
    label: "Ireland (+353)",
    countryCode: "IE",
  },
  {
    diallingCode: "+44",
    label: "Isle Of Man (+44)",
    countryCode: "IM",
  },
  {
    diallingCode: "+972",
    label: "Israel (+972)",
    countryCode: "IL",
  },
  {
    diallingCode: "+39",
    label: "Italy (+39)",
    countryCode: "IT",
  },
  {
    diallingCode: "+225",
    label: "Ivory Coast (+225)",
    countryCode: "CI",
  },
  {
    diallingCode: "+1-876",
    label: "Jamaica (+1-876)",
    countryCode: "JM",
  },
  {
    diallingCode: "+81",
    label: "Japan (+81)",
    countryCode: "JP",
  },
  {
    diallingCode: "+44",
    label: "Jersey (+44)",
    countryCode: "JE",
  },
  {
    diallingCode: "+962",
    label: "Jordan (+962)",
    countryCode: "JO",
  },
  {
    diallingCode: "+7",
    label: "Kazakhstan (+7)",
    countryCode: "KZ",
  },
  {
    diallingCode: "+254",
    label: "Kenya (+254)",
    countryCode: "KE",
  },
  {
    diallingCode: "+686",
    label: "Kiribati (+686)",
    countryCode: "KI",
  },
  {
    diallingCode: "+850",
    label: "Korea (+850)",
    countryCode: "KP",
  },
  {
    diallingCode: "+965",
    label: "Kuwait (+965)",
    countryCode: "KW",
  },
  {
    diallingCode: "+996",
    label: "Kyrgyzstan (+996)",
    countryCode: "KG",
  },
  {
    diallingCode: "+856",
    label: "Lao People's Democratic Republic (+856)",
    countryCode: "LA",
  },
  {
    diallingCode: "+371",
    label: "Latvia (+371)",
    countryCode: "LV",
  },
  {
    diallingCode: "+961",
    label: "Lebanon (+961)",
    countryCode: "LB",
  },
  {
    diallingCode: "+266",
    label: "Lesotho (+266)",
    countryCode: "LS",
  },
  {
    diallingCode: "+231",
    label: "Liberia (+231)",
    countryCode: "LR",
  },
  {
    diallingCode: "+218",
    label: "Libyan Arab Jamahiriya (+218)",
    countryCode: "LY",
  },
  {
    diallingCode: "+423",
    label: "Liechtenstein (+423)",
    countryCode: "LI",
  },
  {
    diallingCode: "+370",
    label: "Lithuania (+370)",
    countryCode: "LT",
  },
  {
    diallingCode: "+352",
    label: "Luxembourg (+352)",
    countryCode: "LU",
  },
  {
    diallingCode: "+853",
    label: "Macao (+853)",
    countryCode: "MO",
  },
  {
    diallingCode: "+389",
    label: "Macedonia (+389)",
    countryCode: "MK",
  },
  {
    diallingCode: "+261",
    label: "Madagascar (+261)",
    countryCode: "MG",
  },
  {
    diallingCode: "+265",
    label: "Malawi (+265)",
    countryCode: "MW",
  },
  {
    diallingCode: "+60",
    label: "Malaysia (+60)",
    countryCode: "MY",
  },
  {
    diallingCode: "+960",
    label: "Maldives (+960)",
    countryCode: "MV",
  },
  {
    diallingCode: "+223",
    label: "Mali (+223)",
    countryCode: "ML",
  },
  {
    diallingCode: "+356",
    label: "Malta (+356)",
    countryCode: "MT",
  },
  {
    diallingCode: "+692",
    label: "Marshall Islands (+692)",
    countryCode: "MH",
  },
  {
    diallingCode: "+596",
    label: "Martinique (+596)",
    countryCode: "MQ",
  },
  {
    diallingCode: "+222",
    label: "Mauritania (+222)",
    countryCode: "MR",
  },
  {
    diallingCode: "+230",
    label: "Mauritius (+230)",
    countryCode: "MU",
  },
  {
    diallingCode: "+262",
    label: "Mayotte (+262)",
    countryCode: "YT",
  },
  {
    diallingCode: "+52",
    label: "Mexico (+52)",
    countryCode: "MX",
  },
  {
    diallingCode: "+691",
    label: "Micronesia (+691)",
    countryCode: "FM",
  },
  {
    diallingCode: "+373",
    label: "Moldova (+373)",
    countryCode: "MD",
  },
  {
    diallingCode: "+377",
    label: "Monaco (+377)",
    countryCode: "MC",
  },
  {
    diallingCode: "+976",
    label: "Mongolia (+976)",
    countryCode: "MN",
  },
  {
    diallingCode: "+382",
    label: "Montenegro (+382)",
    countryCode: "ME",
  },
  {
    diallingCode: "+1-664",
    label: "Montserrat (+1-664)",
    countryCode: "MS",
  },
  {
    diallingCode: "+212",
    label: "Morocco (+212)",
    countryCode: "MA",
  },
  {
    diallingCode: "+258",
    label: "Mozambique (+258)",
    countryCode: "MZ",
  },
  {
    diallingCode: "+95",
    label: "Myanmar (+95)",
    countryCode: "MM",
  },
  {
    diallingCode: "+264",
    label: "Namibia (+264)",
    countryCode: "NA",
  },
  {
    diallingCode: "+674",
    label: "Nauru (+674)",
    countryCode: "NR",
  },
  {
    diallingCode: "+977",
    label: "Nepal (+977)",
    countryCode: "NP",
  },
  {
    diallingCode: "+31",
    label: "Netherlands (+31)",
    countryCode: "NL",
  },
  {
    diallingCode: "+687",
    label: "New Caledonia (+687)",
    countryCode: "NC",
  },
  {
    diallingCode: "+64",
    label: "New Zealand (+64)",
    countryCode: "NZ",
  },
  {
    diallingCode: "+505",
    label: "Nicaragua (+505)",
    countryCode: "NI",
  },
  {
    diallingCode: "+227",
    label: "Niger (+227)",
    countryCode: "NE",
  },
  {
    diallingCode: "+234",
    label: "Nigeria (+234)",
    countryCode: "NG",
  },
  {
    diallingCode: "+683",
    label: "Niue (+683)",
    countryCode: "NU",
  },
  {
    diallingCode: "+672",
    label: "Norfolk Island (+672)",
    countryCode: "NF",
  },
  {
    diallingCode: "+1-670",
    label: "Northern Mariana Islands (+1-670)",
    countryCode: "MP",
  },
  {
    diallingCode: "+47",
    label: "Norway (+47)",
    countryCode: "NO",
  },
  {
    diallingCode: "+968",
    label: "Oman (+968)",
    countryCode: "OM",
  },
  {
    diallingCode: "+92",
    label: "Pakistan (+92)",
    countryCode: "PK",
  },
  {
    diallingCode: "+680",
    label: "Palau (+680)",
    countryCode: "PW",
  },
  {
    diallingCode: "+970",
    label: "Palestinian Territory (+970)",
    countryCode: "PS",
  },
  {
    diallingCode: "+507",
    label: "Panama (+507)",
    countryCode: "PA",
  },
  {
    diallingCode: "+675",
    label: "Papua New Guinea (+675)",
    countryCode: "PG",
  },
  {
    diallingCode: "+595",
    label: "Paraguay (+595)",
    countryCode: "PY",
  },
  {
    diallingCode: "+51",
    label: "Peru (+51)",
    countryCode: "PE",
  },
  {
    diallingCode: "+63",
    label: "Philippines (+63)",
    countryCode: "PH",
  },
  {
    diallingCode: "+870",
    label: "Pitcairn (+870)",
    countryCode: "PN",
  },
  {
    diallingCode: "+48",
    label: "Poland (+48)",
    countryCode: "PL",
  },
  {
    diallingCode: "+351",
    label: "Portugal (+351)",
    countryCode: "PT",
  },
  {
    diallingCode: "+1",
    label: "Puerto Rico (+1)",
    countryCode: "PR",
  },
  {
    diallingCode: "+974",
    label: "Qatar (+974)",
    countryCode: "QA",
  },
  {
    diallingCode: "+82",
    label: "Republic of Korea (+82)",
    countryCode: "KR",
  },
  {
    diallingCode: "+40",
    label: "Romania (+40)",
    countryCode: "RO",
  },
  {
    diallingCode: "+7",
    label: "Russian Federation (+7)",
    countryCode: "RU",
  },
  {
    diallingCode: "+250",
    label: "Rwanda (+250)",
    countryCode: "RW",
  },
  {
    diallingCode: "+262",
    label: "Réunion (+262)",
    countryCode: "RE",
  },
  {
    diallingCode: "+590",
    label: "Saint Barthélemy (+590)",
    countryCode: "BL",
  },
  {
    diallingCode: "+290",
    label: "Saint Helena (+290)",
    countryCode: "SH",
  },
  {
    diallingCode: "+1-869",
    label: "Saint Kitts And Nevis (+1-869)",
    countryCode: "KN",
  },
  {
    diallingCode: "+1-758",
    label: "Saint Lucia (+1-758)",
    countryCode: "LC",
  },
  {
    diallingCode: "+590",
    label: "Saint Martin (+590)",
    countryCode: "MF",
  },
  {
    diallingCode: "+508",
    label: "Saint Pierre And Miquelon (+508)",
    countryCode: "PM",
  },
  {
    diallingCode: "+1-784",
    label: "Saint Vincent And The Grenadines (+1-784)",
    countryCode: "VC",
  },
  {
    diallingCode: "+685",
    label: "Samoa (+685)",
    countryCode: "WS",
  },
  {
    diallingCode: "+378",
    label: "San Marino (+378)",
    countryCode: "SM",
  },
  {
    diallingCode: "+239",
    label: "Sao Tome And Principe (+239)",
    countryCode: "ST",
  },
  {
    diallingCode: "+966",
    label: "Saudi Arabia (+966)",
    countryCode: "SA",
  },
  {
    diallingCode: "+221",
    label: "Senegal (+221)",
    countryCode: "SN",
  },
  {
    diallingCode: "+381",
    label: "Serbia (+381)",
    countryCode: "RS",
  },
  {
    diallingCode: "+248",
    label: "Seychelles (+248)",
    countryCode: "SC",
  },
  {
    diallingCode: "+232",
    label: "Sierra Leone (+232)",
    countryCode: "SL",
  },
  {
    diallingCode: "+65",
    label: "Singapore (+65)",
    countryCode: "SG",
  },
  {
    diallingCode: "+599",
    label: "Sint Maarten (+599)",
    countryCode: "SX",
  },
  {
    diallingCode: "+421",
    label: "Slovakia (+421)",
    countryCode: "SK",
  },
  {
    diallingCode: "+386",
    label: "Slovenia (+386)",
    countryCode: "SI",
  },
  {
    diallingCode: "+677",
    label: "Solomon Islands (+677)",
    countryCode: "SB",
  },
  {
    diallingCode: "+252",
    label: "Somalia (+252)",
    countryCode: "SO",
  },
  {
    diallingCode: "+27",
    label: "South Africa (+27)",
    countryCode: "ZA",
  },
  {
    diallingCode: "+500",
    label: "South Georgia And The South Sandwich Islands (+500)",
    countryCode: "GS",
  },
  {
    diallingCode: "+211",
    label: "South Sudan (+211)",
    countryCode: "SS",
  },
  {
    diallingCode: "+34",
    label: "Spain (+34)",
    countryCode: "ES",
  },
  {
    diallingCode: "+94",
    label: "Sri Lanka (+94)",
    countryCode: "LK",
  },
  {
    diallingCode: "+249",
    label: "Sudan (+249)",
    countryCode: "SD",
  },
  {
    diallingCode: "+597",
    label: "Suriname (+597)",
    countryCode: "SR",
  },
  {
    diallingCode: "+47",
    label: "Svalbard And Jan Mayen (+47)",
    countryCode: "SJ",
  },
  {
    diallingCode: "+268",
    label: "Swaziland (+268)",
    countryCode: "SZ",
  },
  {
    diallingCode: "+46",
    label: "Sweden (+46)",
    countryCode: "SE",
  },
  {
    diallingCode: "+41",
    label: "Switzerland (+41)",
    countryCode: "CH",
  },
  {
    diallingCode: "+963",
    label: "Syrian Arab Republic (+963)",
    countryCode: "SY",
  },
  {
    diallingCode: "+886",
    label: "Taiwan (+886)",
    countryCode: "TW",
  },
  {
    diallingCode: "+992",
    label: "Tajikistan (+992)",
    countryCode: "TJ",
  },
  {
    diallingCode: "+255",
    label: "Tanzania (+255)",
    countryCode: "TZ",
  },
  {
    diallingCode: "+66",
    label: "Thailand (+66)",
    countryCode: "TH",
  },
  {
    diallingCode: "+670",
    label: "Timor-Leste (+670)",
    countryCode: "TL",
  },
  {
    diallingCode: "+228",
    label: "Togo (+228)",
    countryCode: "TG",
  },
  {
    diallingCode: "+690",
    label: "Tokelau (+690)",
    countryCode: "TK",
  },
  {
    diallingCode: "+676",
    label: "Tonga (+676)",
    countryCode: "TO",
  },
  {
    diallingCode: "+1-868",
    label: "Trinidad And Tobago (+1-868)",
    countryCode: "TT",
  },
  {
    diallingCode: "+216",
    label: "Tunisia (+216)",
    countryCode: "TN",
  },
  {
    diallingCode: "+90",
    label: "Turkey (+90)",
    countryCode: "TR",
  },
  {
    diallingCode: "+993",
    label: "Turkmenistan (+993)",
    countryCode: "TM",
  },
  {
    diallingCode: "+1-649",
    label: "Turks And Caicos Islands (+1-649)",
    countryCode: "TC",
  },
  {
    diallingCode: "+688",
    label: "Tuvalu (+688)",
    countryCode: "TV",
  },
  {
    diallingCode: "+256",
    label: "Uganda (+256)",
    countryCode: "UG",
  },
  {
    diallingCode: "+380",
    label: "Ukraine (+380)",
    countryCode: "UA",
  },
  {
    diallingCode: "+971",
    label: "United Arab Emirates (+971)",
    countryCode: "AE",
  },
  {
    diallingCode: "+44",
    label: "United Kingdom (+44)",
    countryCode: "GB",
  },
  {
    diallingCode: "+1",
    label: "United States (+1)",
    countryCode: "US",
  },
  {
    diallingCode: "+1",
    label: "United States Minor Outlying Islands (+1)",
    countryCode: "UM",
  },
  {
    diallingCode: "+1-340",
    label: "United States Virgin Islands (+1-340)",
    countryCode: "VI",
  },
  {
    diallingCode: "+598",
    label: "Uruguay (+598)",
    countryCode: "UY",
  },
  {
    diallingCode: "+998",
    label: "Uzbekistan (+998)",
    countryCode: "UZ",
  },
  {
    diallingCode: "+678",
    label: "Vanuatu (+678)",
    countryCode: "VU",
  },
  {
    diallingCode: "+58",
    label: "Venezuela (+58)",
    countryCode: "VE",
  },
  {
    diallingCode: "+84",
    label: "Vietnam (+84)",
    countryCode: "VN",
  },
  {
    diallingCode: "+681",
    label: "Wallis And Futuna (+681)",
    countryCode: "WF",
  },
  {
    diallingCode: "+212",
    label: "Western Sahara (+212)",
    countryCode: "EH",
  },
  {
    diallingCode: "+967",
    label: "Yemen (+967)",
    countryCode: "YE",
  },
  {
    diallingCode: "+260",
    label: "Zambia (+260)",
    countryCode: "ZM",
  },
  {
    diallingCode: "+263",
    label: "Zimbabwe (+263)",
    countryCode: "ZW",
  },
  {
    diallingCode: "+358",
    label: "Åland Islands (+358)",
    countryCode: "AX",
  },
];
